import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { CardNumberElement, CardExpiryElement, CardCVCElement } from 'react-stripe-elements'
import { Flex, Box } from '@elparking/components'
import CardField from 'commons/js/ui/CardField'
import messages from './messages'

const CreditCardForm = ({ intl }) => (
    <Flex flexWrap='wrap' width='100%'>
        <Box flex={['2 0 100%', '2']} pr={['0', '1em']} mb={['1em', '0']} dataTest='credit-card-form-number-field'>
            <CardField
              model='.creditCard.number'
              cardElement={CardNumberElement}
              label={intl.formatMessage(messages.cardNumberLabel)}
              validateIcon
              validators={{
                    required: (value = { empty: true }) => value && !value.empty,
                    complete: (value = { complete: false }) => value && value.complete,
                }}
              errorMessages={{
                    required: intl.formatMessage(messages.cardNumberRequiredError),
                    complete: intl.formatMessage(messages.cardNumberCompleteError),
                }}
            />
        </Box>
        <Box flex={['1 0 43%', '1']} mr={['2%', '0']} pr={['0', '1em']} mb={['1em', '0']} dataTest='credit-card-form-expiry-field'>
            <CardField
              model='.creditCard.expiry'
              cardElement={CardExpiryElement}
              label={intl.formatMessage(messages.cardExpiryLabel)}
              validateIcon
              validators={{
                    required: (value = { empty: true }) => value && !value.empty,
                    complete: (value = { complete: false }) => value && value.complete,
                }}
              errorMessages={{
                    required: intl.formatMessage(messages.cardExpiryRequiredError),
                    complete: intl.formatMessage(messages.cardExpiryCompleteError),
                }}
            />
        </Box>
        <Box flex={['1 0 43%', '1']} mb='1em' ml={['2%', '0']} dataTest='credit-card-form-cvc-field'>
            <CardField
              model='.creditCard.cvc'
              cardElement={CardCVCElement}
              label={intl.formatMessage(messages.cardCVCLabel)}
              validateIcon
              validators={{
                    required: (value = { empty: true }) => value && !value.empty,
                    complete: (value = { complete: false }) => value && value.complete,
                }}
              errorMessages={{
                    required: intl.formatMessage(messages.cardCVCRequiredError),
                    complete: intl.formatMessage(messages.cardCVCCompleteError),
                }}
            />
        </Box>
    </Flex>
)

CreditCardForm.propTypes = {
    intl: PropTypes.object,
}

export default injectIntl(CreditCardForm)
